module.exports = __webpack_public_path__ + "img/monarch-ui-icon_ORTHOLOG_PHENOTYPE.b053c4ec.png";